import script from "./form-nhom-quyen.vue?vue&type=script&setup=true&lang=js"
export * from "./form-nhom-quyen.vue?vue&type=script&setup=true&lang=js"

import "./form-nhom-quyen.vue?vue&type=style&index=0&id=c8b4ec84&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8b4ec84"]])

export default __exports__